<template>
	<div>
		<clientModule moduletitle="选择账户结构并填写必需参数" class="bg divHeight" v-if="isgenerate">
			<div class="tab bg">
				<div
					v-for="(item, index) in tabList"
					:key="index"
					:class="['tab-item', { 'tab-active': index == activeValue }]"
					@click="change(index)"
				>
					{{ item.name }}
				</div>
			</div>
		</clientModule>
		<adsCountry :type="type" v-if="isadd" :isgenerate="isgenerate" :name="name"></adsCountry>
		<div class="bottom" v-if="butVisble">
			<el-button type="primary" size="medium" :loading="butttonloading" @click="account_building">{{
				butText
			}}</el-button>
		</div>
	</div>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule';
import adsCountry from '@/components/accountOnline/adsCountry';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
export default {
	data() {
		return {
			activeValue: 0,
			tabList: [
				{
					name: '(国家/地区)作为广告系列',
					type: 1,
				},
				{
					name: '核心推广产品作为广告系列',
					type: 0,
				},
			],
			loading: false,
			isgenerate: true,
			isadd: false,
			butttonloading: false,
			butText: '确认无误，一键搭建账户',
			timer: null,
			searchStatus: null,
			butVisble: true,
		};
	},

	components: { clientModule, adsCountry },
	computed: {
		name() {
			return this.tabList[this.activeValue].name;
		},
		type() {
			return this.tabList[this.activeValue].type;
		},
		queryParam() {
			return this.$route.query;
		},
	},
	watch: {
		'queryParam.automationStatus': {
			handler(val) {
				if (val == 5) {
					this.getSearchStatus();
					this.getText();
				}
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		change(index) {
			this.activeValue = index;
		},
		async AddData() {
			let res = await adsNewOnlineSer.add_ads(
				{ automationId: this.queryParam.automationId },
				{ serviceSiteId: this.queryParam.serviceSiteId }
			);
			this.isadd = res.data == 'success' ? true : false;
		},
		changePage(val) {
			this.searchStatus = val;
			if (val == 5) {
				this.isgenerate = false;
			}
		},
		async account_building() {
			this.butttonloading = true;
			try {
				let res = await adsNewOnlineSer.account_building(
					{ type: this.type, automationId: this.queryParam.automationId },
					{ serviceSiteId: this.queryParam.serviceSiteId }
				);
				this.butText = '账户搭建中，可退出此界面';
				if (res.status == 200) {
					this.getText(1);
				}
			} catch (error) {
				this.butttonloading = false;
			}
		},
		getText(val) {
			this.timer = setInterval(() => {
				this.getSearchStatus(val);
			}, 3000);
		},
		async getSearchStatus(state) {
			let res = await adsNewOnlineSer.searchStatus({ automationId: this.queryParam.automationId });
			this.searchStatus = res.data.status;
			if (this.searchStatus == 5 || this.searchStatus == 4) {
				this.changePage(this.searchStatus);
			}
			if (this.searchStatus == 5) {
				this.butttonloading = true;
				this.butText = '账户搭建中，可退出此界面';
			}

			if (this.searchStatus == 4) {
				this.butVisble = false;
				this.$message({
					message: '搭建成功',
					type: 'success',
				});
			}

			if (this.searchStatus == 4 || this.searchStatus == 6) {
				clearInterval(this.timer);
				this.butttonloading = false;
				this.timer = null;
			}
			if (this.searchStatus == 6) {
				this.isgenerate = true;
				this.butText = '确认无误，重新搭建账户';
				this.$message.error({
					message: '搭建失败，请返回列表查看失败原因',
				});
			}
		},
	},
	created() {
		this.AddData();
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null;
	},
};
</script>

<style lang="scss" scoped>
.bg {
	background: #ffffff;
}
.divHeight {
	height: 163px;
}
.tab {
	display: flex;
	margin: 30px;
}
.tab-item {
	width: 208px;
	height: 46px;
	color: #3da1ff;
	border: 1px solid #3da1ff;
	border-radius: 4px;
	text-align: center;
	line-height: 46px;
	font-size: 16px;
	font-weight: 400;
	margin-left: 20px;
	cursor: pointer;
}
.tab-active {
	color: #ffffff;
	background: #3da1ff;
}
.bottom {
	text-align: right;
	line-height: 70px;
	margin-top: 20px;
	height: 70px;
	padding-right: 50px;
	background: #ffffff;
	box-shadow: 0px -4px 4px 0px rgba(51, 51, 51, 0.05);
}
</style>
